import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions } from "@material-ui/core";
import { CustomTextField } from "../../../partials/content/Forms";
import DialogLayout from "../../../partials/content/DialogLayout";
import CustomDataTableBasic from "../../../partials/content/CustomDataTableBasic";
import { getNotes, saveNote, deleteNote } from "../../../services/commons";
import { formatDate } from "../../../utils/utils";
import { onPreventEnterSubmitting } from "../../../utils/utils";
import { Editor } from "primereact/editor";
import Swal from "sweetalert2";
import ResponsiveEllipsis from "../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../partials/content/BootstrapTooltip";
import Illustration from "../../../partials/content/Illustration";
import { useGlobalData } from "../../../../provider/GlobalDataProvider";
import store from "../../../store/store";
import { DateTime } from "luxon";
function Notes({ docType = "", docID = 0 }) {
  const { reload } = useGlobalData();
  const [notes, setNotes] = useState([]);
  const [noteData, setNoteData] = useState({
    ID: 0,
    docType: docType,
    docID: docID,
    title: "",
    note: "",
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });
  const [openNoteForm, setOpenNoteForm] = useState(false);
  const { auth } = store.getState();
  const userID = auth.user.userID;
  useEffect(() => {
    getNotesData(docType, docID);
  }, [docType, docID, reload]);

  const noteFormSchema = yup.object().shape({
    ID: yup.number(),
    title: yup
      .string()
      .required("Title is Required")
      .max(255, "Note Title maximum characters is 255"),
    note: yup.string().required("Note Content is Required"),
  });

  return (
    <React.Fragment>
      {notes.length ? (
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              className="btn btn-primary btn-md btn-pill btn-bold"
              onClick={() => {
                setNoteData({ ...noteData, ID: 0, title: "", note: "" });
                setOpenNoteForm(true);
              }}
            >
              <i className="fas fa-plus-circle"></i>
              New Note
            </button>
          </div>
        </div>
      ) : null}
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          {notes.length ? (
            <CustomDataTableBasic
              data={notes}
              onRefreshData={() => {
                getNotesData(docType, docID);
              }}
              onSelectedData={(rowData, originalEvent) => {
                let cellIndex = find_cellIndex(originalEvent.target);
                if (cellIndex !== 4) {
                  setNoteData(rowData);
                  setOpenNoteForm(true);
                }
              }}
              columns={[
                {
                  header: "Note Title",
                  field: "title",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.title} maxLine="1" />
                    </React.Fragment>
                  ),
                  sortable: true,
                },
                {
                  header: "Note Content",
                  field: "note",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.note.replace(/<[^>]+>/g, "")}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  width: "40%",
                },
                {
                  header: "Posted By",
                  field: "postedByUser.fullName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.postedByUser.fullName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                },
                {
                  header: "Posted At",
                  field: "CreatedAt",
                  body: (rowData) => (
                    <React.Fragment>
                      {formatDate(rowData.CreatedAt, true)}
                    </React.Fragment>
                  ),
                  sortable: true,
                },
                {
                  header: "Actions",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.postedBy === userID ? (
                        <BootstrapTooltip title="Delete Note">
                          <button
                            type="button"
                            onClick={() => deleteNoteData(rowData.ID)}
                            className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                    </React.Fragment>
                  ),
                  sortable: false,
                },
              ]}
            />
          ) : (
            <React.Fragment>
              <Illustration
                imageSource="INVIFO Setup.png"
                guidance="Hooray! You're ready to have your first Note for this document!"
                guidanceLeftIcon="fas fa-info-circle kt-font-success"
                size="md"
              ></Illustration>
              <div className="text-center py-3">
                <button
                  type="button"
                  className="btn btn-primary btn-md btn-pill btn-bold mx-1"
                  onClick={() => {
                    setNoteData({ ...noteData, ID: 0, title: "", note: "" });
                    setOpenNoteForm(true);
                  }}
                >
                  <i className="fas fa-plus-circle"></i>
                  New Note
                </button>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
      <DialogLayout
        open={openNoteForm}
        title="Notes Form"
        onCloseDialog={() => {
          setOpenNoteForm(false);
        }}
        maxWIdth="lg"
      >
        <Formik
          initialValues={noteData}
          enableReinitialize={true}
          validationSchema={noteFormSchema}
          onSubmit={async (values, { setStatus, setSubmitting }) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            })
              .fire({
                title: "Are you sure want to save this Note ?",
                text: "Please note that you are responsible for this action",
                icon: "question",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
                cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                reverseButtons: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  saveNote(values).then((response) => {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Saved",
                      html: response.data.message,
                      icon: "success",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                    getNotesData(docType, docID).then((response) => {
                      setOpenNoteForm(false);
                    });
                  });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Cancelled",
                    text: "No change has been made",
                    icon: "info",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                }
              });
          }}
        >
          {({
            values,
            status,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form
              noValidate={true}
              autoComplete="off"
              className="kt-form"
              onSubmit={handleSubmit}
              onKeyDown={onPreventEnterSubmitting}
            >
              <CustomTextField
                label="Note Title"
                inputType="text"
                propertyName="title"
                onBlur={handleBlur}
                onChange={handleChange}
                values={values}
                touched={touched}
                errors={errors}
                endAdornment={
                  noteData.postedBy !== userID && noteData.ID > 0
                    ? {
                        readOnly: true,
                      }
                    : {
                        readOnly: false,
                      }
                }
                disabled={
                  noteData.postedBy !== userID && noteData.ID > 0 ? true : false
                }
                size="small"
              />
              <br />
              <Editor
                style={{ height: "280px", width: "100%" }}
                onTextChange={(e) => {
                  setFieldValue("note", e.htmlValue);
                }}
                value={values.note}
                placeholder="Type your notes here..."
                readOnly={
                  noteData.postedBy !== userID && noteData.ID > 0 ? true : false
                }
                className={
                  noteData.postedBy !== userID && noteData.ID > 0
                    ? "editor-grey"
                    : ""
                }
              />
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenNoteForm(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Cancel
                </button>
                {noteData.postedBy === userID || noteData.ID === 0 ? (
                  <button
                    type="submit"
                    className="btn btn-success btn-md btn-pill btn-bold"
                    disabled={isSubmitting}
                  >
                    <i className="fas fa-save"></i>
                    Save
                  </button>
                ) : null}
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogLayout>
    </React.Fragment>
  );

  async function getNotesData(docType, docID) {
    const response = await getNotes(docType, docID);
    const { data } = response.data;
    setNotes(data.notes);
  }

  async function deleteNoteData(noteID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Note ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteNote(noteID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getNotesData(docType, docID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  function find_cellIndex(target) {
    if (target.cellIndex !== undefined) return target.cellIndex;
    if (target.parentElement) return find_cellIndex(target.parentElement);
  }
}

export default Notes;
